import React from 'react';
import {Checkbox, Form} from 'semantic-ui-react';
import makeComp from '../util/profiler';

interface CheckboxFormOption {
  label: string;
  key: string;
}

interface CheckboxFormProps {
  name?: string;
  options: CheckboxFormOption[];
  value: {[key: string]: boolean};
  onChange: (newValue: {[key: string]: boolean}) => void;
}

const CheckboxForm: React.FC<CheckboxFormProps> = makeComp(
  props => {
    return (
      <>
        {props.options.map(option => (
          <Form.Field
            control={Checkbox}
            label={option.label}
            checked={props.value[option.key]}
            key={props.name ? props.name + ':' + option.key : option.key}
            onChange={() =>
              props.onChange(
                Object.assign({}, props.value, {
                  [option.key]: !props.value[option.key],
                })
              )
            }
          />
        ))}
      </>
    );
  },
  {id: 'CheckboxForm'}
);

export default CheckboxForm;
